import { PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { message, Input, Select, Tooltip, Radio, Alert, Checkbox } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputItem,
  InputNumberItem,
  SelectItem,
  TextAreaItem,
  DatePickerItem,
  ButtonItem,
  ErrorItem,
  NotificacionPolizas,
  cuentaMask,
} from "../../../../Components/Items";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";

const { Option } = Select;

class AgregarCredito extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoCuentaContable: null,
    objetoMonedas: null,
    todasMonedas: null,
    objetoProyectos: null,
    monedaEsMXN: true,
    modalAgregarCuentaContable: false,
    contablemente: true,
    confirmoRevision: false,
    abonoProveedor: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoCuentaContable: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                ) +
                  " - " +
                  value.descripcion}
              </Option>
            )),
          });
        }
      });
    await axios
      .post("monedas/selectMonedas", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasMonedas: res.data,
            objetoMonedas: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + " - " + value.abreviacion}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    this.setState({ loading: false });
  }

  onChangeMoneda = (id) => {
    const moneda = this.state.todasMonedas?.find((m) => m._id === id);
    const esMXN = moneda?.abreviacion === "MXN";
    this.setState({ monedaEsMXN: esMXN });
    if (esMXN) {
      this.formRef.current.setFieldsValue({ tipoCambio: 1 });
    } else {
      this.formRef.current.setFieldsValue({ tipoCambio: undefined });
    }
  };

  onChangeAbonoProveedor = (e) => {
    const abonoProveedor = e.target.value;

    this.setState({
      abonoProveedor,
      //El abono al proveedor necesita poliza: sin ella el cargo a la cuenta de
      //anticipos nunca ocurre y el abono la descuadra al aplicarse
      contablemente: abonoProveedor ? true : this.state.contablemente,
      confirmoRevision: false,
    });

    if (abonoProveedor) {
      //La cuenta de cargo se oculta, y el pago inicial no aplica en esta modalidad
      this.formRef.current.setFieldsValue({
        cuentaContableCargoId: undefined,
        totalPagado: 0,
      });
    }
  };

  cerrarAgregarCredito() {
    this.setState({
      monedaEsMXN: true,
      contablemente: true,
      confirmoRevision: false,
      abonoProveedor: false,
    });
    this.props.cerrarAgregarCredito();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (!this.state.contablemente && !this.state.confirmoRevision) {
      message.error(
        "Confirma que revisaste que la contabilidad ya está correcta"
      );
      return;
    }

    this.setState({ loading: true });
    axios
      .post(
        "creditos/agregarCredito",
        {
          ...values,
          //En modalidad de abono no hay cuenta de cargo ni pago inicial: la
          //contrapartida la resuelve el backend con la cuenta del proveedor
          cuentaContableCargoId: this.state.abonoProveedor
            ? undefined
            : values.cuentaContableCargoId,
          totalPagado: this.state.abonoProveedor ? 0 : values.totalPagado,
          abonoProveedor: this.state.abonoProveedor,
          contablemente: this.state.abonoProveedor
            ? true
            : this.state.contablemente,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se agregó un crédito");
          if (res.data.polizasId?.length) {
            NotificacionPolizas(res.data.polizasId);
          }
          this.formRef.current.resetFields();
          this.cerrarAgregarCredito();
        } else {
          message.error(res.data.message || "Sucedió un error y no se guardó");
        }
      });
  }

  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }

  render() {
    return (
      <>
        <ModalItem
          title="Agregar Crédito"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarAgregarCredito.bind(this)}
        >
          <Form
            ref={this.formRef}
            name="agregarCredito"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Agregar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
            initialValues={{ totalPagado: 0, tipoCambio: 1 }}
          >
            <FormItem name="nombre" label="Nombre" required margin pattern>
              <InputItem placeholder="Nombre" />
            </FormItem>
            <FormItem name="descripcion" label="Descripción" margin pattern>
              <TextAreaItem placeholder="Descripción" />
            </FormItem>
            <FormItem label="Proveedor" name="proveedorId" required margin>
              <SelectProveedoresItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                placeholder="Proveedor"
              />
            </FormItem>
            <FormItem label="Proyecto" name="proyectoId" required margin>
              <SelectItem placeholder="Proyecto">
                {this.state.objetoProyectos}
              </SelectItem>
            </FormItem>
            <FormItem
              name="totalCredito"
              label="Total del Crédito"
              required
              number
              margin
            >
              <InputNumberItem dinero placeholder="Total del Crédito" />
            </FormItem>
            {!this.state.abonoProveedor && (
              <FormItem
                name="totalPagado"
                label="Total Pagado"
                numberCero
                margin
                initialValue={0}
              >
                <InputNumberItem dinero placeholder="Total Pagado" />
              </FormItem>
            )}
            <FormItem label="Moneda" name="monedaId" required margin>
              <SelectItem
                placeholder="Moneda"
                onChange={this.onChangeMoneda}
              >
                {this.state.objetoMonedas}
              </SelectItem>
            </FormItem>
            {!this.state.monedaEsMXN && (
              <FormItem
                name="tipoCambio"
                label="Tipo de Cambio"
                required
                number
                margin
              >
                <InputNumberItem placeholder="Tipo de Cambio" />
              </FormItem>
            )}
            <FormItem
              label={
                <span>
                  Cuenta Contable Crédito&nbsp;
                  <Tooltip title="De donde viene el dinero prestado. Ej: 'el banco me prestó $100,000'. Es la cuenta del banco o proveedor que te dio el crédito. En la póliza inicial aparece como abono (aumenta lo que debes).">
                    <QuestionCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                  </Tooltip>
                </span>
              }
              margin
            >
              <Input.Group compact>
                <FormItem name="cuentaContableCreditoId" required noStyle>
                  <SelectItem
                    placeholder="Cuenta Acreedor"
                    width="80%"
                  >
                    {this.state.objetoCuentaContable}
                  </SelectItem>
                </FormItem>
                <ButtonItem
                  icon={<PlusOutlined />}
                  style={{ width: "20%" }}
                  onClick={this.abrirAgregarCuentaContable.bind(this)}
                />
              </Input.Group>
            </FormItem>
            <FormItem label="¿A dónde va el dinero del crédito?" margin>
              <Radio.Group
                value={this.state.abonoProveedor}
                onChange={this.onChangeAbonoProveedor}
              >
                <Radio value={false}>A una cuenta contable</Radio>
                <Radio value={true}>Como abono al proveedor</Radio>
              </Radio.Group>
            </FormItem>
            {this.state.abonoProveedor ? (
              <Alert
                type="info"
                showIcon
                message="El cargo se hará a la cuenta de anticipos del proveedor."
                description="Además de la póliza se genera un abono a proveedor (serie AP) por el total del crédito, que podrás aplicar a sus facturas desde Cuentas Por Pagar. En esta modalidad no se puede capturar pago inicial ni dar de alta el crédito sin contabilidad."
                style={{ marginBottom: 12 }}
              />
            ) : (
              /* Se oculta en vez de deshabilitarse: el FormItem de adentro es
                 required y bloquearia el envio del formulario */
              <FormItem
                label={
                  <span>
                    Cuenta Contable Cargo&nbsp;
                    <Tooltip title="Ahí es donde vas a recibir el dinero en la póliza inicial. Ej: 'esos $100,000 cayeron a mi cuenta de cheques / los usé para comprar maquinaria'. Aparece como cargo (entra el recurso).">
                      <QuestionCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                    </Tooltip>
                  </span>
                }
                margin
              >
                <Input.Group compact>
                  <FormItem name="cuentaContableCargoId" required noStyle>
                    <SelectItem
                      placeholder="Cuenta Cargo (Banco)"
                      width="80%"
                    >
                      {this.state.objetoCuentaContable}
                    </SelectItem>
                  </FormItem>
                  <ButtonItem
                    icon={<PlusOutlined />}
                    style={{ width: "20%" }}
                    onClick={this.abrirAgregarCuentaContable.bind(this)}
                  />
                </Input.Group>
              </FormItem>
            )}
            <FormItem label="¿Registrar el crédito contablemente?" margin>
              <Radio.Group
                value={this.state.contablemente}
                onChange={(e) =>
                  this.setState({
                    contablemente: e.target.value,
                    confirmoRevision: false,
                  })
                }
              >
                <Radio value={true}>Sí, crear póliza contable</Radio>
                <Radio value={false} disabled={this.state.abonoProveedor}>
                  No, la contabilidad ya está registrada
                </Radio>
              </Radio.Group>
            </FormItem>
            {!this.state.contablemente && (
              <div style={{ marginBottom: 12 }}>
                <Alert
                  type="warning"
                  showIcon
                  message="Vas a dar de alta el crédito sin generar pólizas."
                  description="No se creará ni la póliza del crédito ni la del pago inicial. Verifica que la contabilidad ya refleje este crédito antes de continuar. Las cuentas contables se siguen guardando porque se usan al pagar o aumentar el crédito."
                  style={{ marginBottom: 8 }}
                />
                <Checkbox
                  checked={this.state.confirmoRevision}
                  onChange={(e) =>
                    this.setState({ confirmoRevision: e.target.checked })
                  }
                >
                  Confirmo que revisé que la contabilidad está correcta
                </Checkbox>
              </div>
            )}
            <FormItem
              name="fechaInicio"
              label="Fecha de Inicio"
              margin
            >
              <DatePickerItem
                placeholder="Fecha de Inicio"
                allowClear={false}
              />
            </FormItem>
            <FormItem
              name="fechaVencimiento"
              label="Fecha de Vencimiento"
              margin
            >
              <DatePickerItem
                placeholder="Fecha de Vencimiento"
                allowClear={false}
              />
            </FormItem>
            <FormItem name="plazo" label="Plazo (meses)" number margin>
              <InputNumberItem placeholder="Plazo en meses" />
            </FormItem>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this
          )}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarCredito);
